import { CommonModule } from '@angular/common';
import { Component, Input, inject, OnInit } from '@angular/core';
import { ChartRow } from '../../../model/impact-analysis.model';
import { SearchConfig, API_STATUS } from '../../../model/api.model';
import { CommonService } from '../../../services/common.service';
import { CommonUtils } from '../../../utils/common.utils';
import { LoadingSkeletonComponent } from '../../../layout/loading-skeleton/loading-skeleton.component';

@Component({
  selector: 'app-impact-analysis-incompletion-chart',
  standalone: true,
  imports: [CommonModule, LoadingSkeletonComponent],
  templateUrl: './impact-analysis-incompletion-chart.component.html',
  styleUrl: './impact-analysis-incompletion-chart.component.scss'
})
export class ImpactAnalysisIncompletionChartComponent implements OnInit {
  private readonly commonService = inject(CommonService);
  private readonly commonUtils = inject(CommonUtils);
  spinnerName = 'chart';

  @Input() chartRows: Array<ChartRow> = [];
  @Input() courseRows: any[] = [];
  @Input() loading = false;
  @Input()
  set elementId(value: any) {
    this.spinnerName = String(value ?? 'chart');
  }
  @Input() groupType!: any;
  @Input() apiConfig?: SearchConfig;

  ngOnInit() {
    if (this.apiConfig) {
      this.fetchCourseData();
    }
  }

  private async fetchCourseData() {
    if (!this.apiConfig) {return};
    
    try {
      this.loading = true;
      this.commonUtils.spinner('show', this.spinnerName as any);
      const response = await this.commonService.getDataFromDataSource(this.apiConfig,this.apiConfig.urlPath ?? '');
      if (response?.status === API_STATUS.Success && Array.isArray(response.result)) {
        this.courseRows = response.result;
      }
    } catch (error) {
      console.info('Course data fetch failed', error);
      this.courseRows = [];
    } finally {
      this.loading = false;
      this.commonUtils.spinner('hide', this.spinnerName as any);
    }
  }

  trackByText(_: number, item: ChartRow): string {
    return item.name;
  }
}
